// ABOUTME: Prepares generic translations before mounting a public not-found page.
// ABOUTME: Prevents old tenant namespaces from loading during a route transition.
import React from "react";
import "../i18n/i18n";
import { i18f, setTranslationPathSource } from "../i18n/i18n";
import HelperLoading from "Components/Loading/HelperLoading";

const UnAuthenticatedNotFound = (props: any) => {
    const plan = "noplan";
    const translationPath = `${import.meta.env.VITE_API_ADDRESS}/general/translation/0/0`;
    const [readyTranslationPath, setReadyTranslationPath] = React.useState(() =>
        localStorage.getItem("i18nPath")
    );
    React.useEffect(() => {
        const currentPath = localStorage.getItem("i18nPath");

        if (translationPath !== currentPath) {
            i18f(translationPath, "public_not_found");
        }
        setReadyTranslationPath(translationPath);
    }, [plan, translationPath]);

    if (readyTranslationPath !== translationPath) {
        return <HelperLoading />;
    }

    // Written during render on purpose: children can request translation
    // namespaces while rendering, before any effect runs, and the generic-path
    // diagnostic must attribute them to this transition.
    setTranslationPathSource("public_not_found");
    // return React.cloneElement(props.children, {
    //     ...props
    // });
    return <React.Fragment>{props.children}</React.Fragment>;
};

export default UnAuthenticatedNotFound;
